'use strict';

export default angular
  .module('maestro.services.data.notification', [
    'maestro.services.webcore'
  ])
  .service('NotificationService', NotificationService)
  .name;

function NotificationService(webcore, $q, CacheService) {

  /**
   * Gets a list of notification groups in organization.
   * @param {number} organizationId
   * @param {number} [groupId] Filter by group
   * @returns {Promise}
   */
  this.getNotificationGroups = (organizationId, groupId) => {
    if (!organizationId || organizationId < 1 || isNaN(organizationId)) {
      return $q.reject('Organization ID is not specified!');
    }

    return $q.when(
      webcore.services.notification.getNotificationGroups(organizationId, groupId)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };

  /**
   * Create or update notification group in organization.
   * @param {number} organizationId
   * @param {NotificationGroupModel} group
   * @returns {Promise}
   */
  this.createOrUpdateNotificationGroup = (organizationId, group) => {
    if (!organizationId || organizationId < 1 || isNaN(organizationId)) {
      return $q.reject('Organization ID is not specified!');
    }

    return $q.when(
      webcore.services.notification.createOrUpdateNotificationGroup(organizationId, group)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  }

  /**
   * Delete a notification group in organization.
   * @param {number} organizationId
   * @param {number} groupId
   * @returns {Promise}
   */
  this.deleteNotificationGroup = (organizationId, groupId) => {
    if (!organizationId || organizationId < 1 || isNaN(organizationId)) {
      return $q.reject('Organization ID is not specified!');
    }

    return $q.when(
      webcore.services.notification.deleteNotificationGroup(organizationId, groupId)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  }

  /**
   * Manage organization notification users.
   * @param {number} organizationId
   * @param {UpdateNotificationUsersModel} users
   * @returns {Promise}
   */
  this.updateNotificationUsers = (organizationId, users) => {
    if (!organizationId || organizationId < 1 || isNaN(organizationId)) {
      return $q.reject('Organization ID is not specified!');
    }

    return $q.when(
      webcore.services.notification.updateNotificationUsers(organizationId, users)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };

  /**
   * Get notification group assignments (settings).
   * See {@link https://sboxall.peoplepowerco.com/cloud/apidocs/admin.html#tag/Notifications/operation/Get%20Notification%20Assignments}
   *
   * @param {number} organizationId Organization ID
   * @returns {Promise}
   */
  this.getNotificationGroupSettings = (organizationId) => {
    if (!organizationId || organizationId < 1 || isNaN(organizationId)) {
      return $q.reject('Organization ID is not specified!');
    }

    return $q.when(
      webcore.services.notification.getNotificationGroupAssignments(organizationId)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  }

  /**
   * Updates notification group assignments (settings)
   * See {@link https://sboxall.peoplepowerco.com/cloud/apidocs/bots.html#tag/End-User-Bot-Shop-APIs/operation/Update%20Bot%20Notifications}
   *
   * @param {number} organizationId Organization ID
   * @param {Object} settings Notification settings to update
   * @returns {Promise}
   */
  this.updateNotificationGroupSettings = (organizationId, settings) => {
    if (!organizationId || organizationId < 1 || isNaN(organizationId)) {
      return $q.reject('Organization ID is not specified!');
    }

    return $q.when(
      webcore.services.notification.updateNotificationGroupAssignments(organizationId, settings)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  }

}
